<template>
    <div class="app">
        <div class="title">
            <span style="color: #999999">入院状态:&nbsp;&nbsp;
                <span :class="{blue: medicalInfo.signState =='已预约',green: medicalInfo.signState =='已入院'}">{{medicalInfo.signState}}</span>
            </span>
        </div>
        <div class="content">
            <ul class="user-info">
                <li>
                    <span class="left">医院</span>
                    <span class="right">{{hospitalName}}</span>
                </li>
                <li>
                    <span class="left">登记号</span>
                    <span class="right">{{medicalInfo.patientId}}</span>
                </li>
                <li>
                    <span class="left">病人姓名</span>
                    <span class="right">{{medicalInfo.name}}</span>
                </li>
                <li>
                    <span class="left">性别</span>
                    <span class="right">{{medicalInfo.sex}}</span>
                </li>
                <li>
                    <span class="left">年龄</span>
                    <span class="right">{{age}}</span>
                </li>
                <li>
                    <span class="left">身份证号码</span>
                    <span class="right">{{medicalInfo.idCardNo | dotted}}</span>
                </li>
                <li>
                    <span class="left">联系电话</span>
                    <span class="right">{{medicalInfo.phoneNo | dotted}}</span>
                </li>
                <li>
                    <span class="left">病人类型</span>
                    <span class="right">{{medicalInfo.feeType}}</span>
                </li>
                <li>
                    <span class="left">住院科室</span>
                    <span class="right">{{medicalInfo.deptName}}</span>
                </li>
                <li>
                    <span class="left">诊断类型</span>
                    <span class="right">{{medicalInfo.diagnosisType}}</span>
                </li>
                <li>
                    <span class="left">开入院证医生</span>
                    <span class="right">{{medicalInfo.doctName}}</span>
                </li>
                <li>
                    <span class="left">开入院证时间</span>
                    <span class="right">{{medicalInfo.inTime}}</span>
                </li>
            </ul>
            <div class="diagnosis" v-if="medicalInfo.signState == '已预约'">
                <span style="color:#A2A2A2">诊疗描述:</span>
                <div class="confirm">
                    <textarea id="input-content" class="input" v-model="medicalInfo.diagnosisDesc"></textarea>
                </div>
            </div>
            <div class="location" style="margin-top: 0.5rem" v-if="medicalInfo.signState == '已入院'">
                <span class="left">住院位置：</span>
                <span>{{location}}</span>
            </div>
            <div class="footer" style="margin:0.5rem 0" v-if="medicalInfo.signState == '已入院'">
                <div><span class="color-blue">入院提示：</span></div>
                <span class="color-gray">1、入院登记成功后，请前往住院预交金进行充值。</span></br>
                <span class="color-gray">2、入院后，如需申请住院报销，请及时医保科进行登记。</span>
            </div>
        </div>
        <div class="ok-wrap" v-if="medicalInfo.signState == '已预约'">
           <button id="feedback-submit" class="btn-ok" type="button" @click="submitInpatient()">确认登记</button>
        </div>
        <div class="ok-wrap" v-if="medicalInfo.signState == '已入院'&&medicalInfo.status != '4'">
           <button id="feedback-submit" class="btn-ok" type="button" @click="goRecharge()">住院预交金充值</button>
        </div>
        <tips v-model="showTips">
            <span slot="title" style="color: white">温馨提示</span>
            <div slot="list" class="tip-content">{{tips}}</div>
        </tips>
    </div>
</template>

<script>
import tips from 'Tips'
import inpatientRecharge from "inpatientRecharge.service"
export default {
  components: {
    tips
  },
  data () {
    return {
      cardNo: '',
      cardType: '',
      tips: '',
      hospitalName: '',
      medicalInfo: {},
      age: '',
      location: '',
      showTips: false
    }
  },
  created () {
    this.medicalInfo = JSON.parse(localStorage.getItem('inpatientList'))
    let sex = this.medicalInfo.sex
    let aDate = new Date()
    let thisYear = aDate.getFullYear()
    let bDate = new Date(this.medicalInfo.birthday)
    let brith = bDate.getFullYear()
    this.age = thisYear - brith
    this.medicalInfo.sex = sex == '1' ? '男' : (sex == '2' ? '女' : '未知')
    this.hospitalName = this.$route.query.hospitalName
    this.cardNo = this.$route.query.cardNo
    this.cardType = this.$route.query.cardType
    this.location = this.medicalInfo.deptName + this.medicalInfo.areaNo + '病区' + this.medicalInfo.bedNo + '床号'
  },
  methods: {
    submitInpatient () {
      if (this.medicalInfo.status !== '1' || !this.medicalInfo.elecCertId) {
        this.tips = '登记失败,请重新登记'
        this.showTips = true
        return
      }
      inpatientRecharge.submitInpatient({
        cardNo: this.cardNo,
        cardType: this.cardType,
        elecCertId: this.medicalInfo.elecCertId
      }).then((res) => {
        if (res.resultCode == this.constant.RESULT_SUCCESS) {
          this.tips = '入院登记成功'
          this.showTips = true
          this.medicalInfo.signState = '已入院'
          this.medicalInfo.areaNo = res.data.areaNo
          this.medicalInfo.bedNo = res.data.bedNo
          this.location = this.medicalInfo.deptName + this.medicalInfo.areaNo + '病区' + this.medicalInfo.bedNo + '床号'
        } else {
          this.tips = '登记失败,请重新登记'
          this.showTips = true
          return
        }
      })
    },
    goRecharge () {
      this.$router.replace('InpatientRecharge')
    }
  }
}
</script>

<style lang="scss">
.app {
  background-color: #eff3f6;
  padding-bottom: 3.75rem;
  .message-pop-content {
    width: 13rem;
    left: 50%;
    margin-left: -6.5rem;
    height: 8rem;
    border-radius: 0.15rem;
  }
  .message-box-title {
    border-radius: 0.15rem 0.15rem 0 0;
  }
  .message-scroll {
    border-radius: 0 0 0.15rem 0.15rem;
  }
  .popup-message-box {
    background-color: rgba(0, 0, 0, 0.5);
  }
  .tip-content {
    text-align: center;
    padding: 1.75rem 0;
  }
}
</style>

<style lang="scss" scoped>
.app {
  background-color: #eff3f6;
  padding-bottom: 1.5rem;
  display: flex;
  flex-flow: column;
  min-height: 100vh;
  .title {
    height: 2rem;
    line-height: 2rem;
    text-align: center;
    .blue {
      color: #1fa9f0;
    }
    .green {
      color: #57d3ba;
    }
  }
  .content {
    flex: 1;
    .user-info {
      margin-bottom: 0.625rem;
      background-color: #fff;
      li {
        height: 1rem;
        line-height: 1rem;
        display: flex;
        justify-content: space-between;
        padding: 0 0.85rem;
        border-bottom: 0.05rem solid #f0f1f5;
        &:last-child {
          border: none;
        }
        .left {
          color: #a2a2a2;
        }
      }
    }
    .diagnosis {
      background-color: #fff;
      height: 7rem;
      span {
        display: inline-block;
        margin: 0.5rem 0.5rem;
      }
      .confirm {
        margin: 0 0.5rem;
        border-radius: 0.25rem;
        border: 0.025rem solid #bfbfbf;
        overflow: hidden;
        .input {
          width: 100%;
          box-sizing: border-box;
          padding: 0.5rem 0.5rem;
          letter-spacing: 1px;
          height: 2.5rem;
          outline: none;
          resize: none;
        }
      }
    }
    .location {
      height: 2rem;
      line-height: 2rem;
      background-color: #fff;
      padding-left: 0.85rem;
      .left {
        color: #a2a2a2;
      }
    }
    .footer {
      font-size: 13px;
      padding: 0 0.75rem;
    }
  }
  .color-blue {
    color: #52a8ed;
  }
  .color-gray {
    color: #999999;
  }
  .ok-wrap {
    flex: 0;
    padding: 0.5rem;
    height: 1rem;
    .btn-ok {
      letter-spacing: 1px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// InpatientDetails.vue?44b2d0a2